module.exports = __webpack_public_path__ + "img/woman_running.ab0dfec1.gif";